import React from "react";
// import { useTranslation } from "react-i18next";
import Image from "../../../components/image";
import { asset } from "../../../helpers/dom.helper";
import {PACKAGING_BLOG} from "../../packagingBlog/packagingBlogJson"
import "./style.scss";
import { Link } from "react-router-dom";
import { toRoute } from "../../../i18n";
import { Media, MediaContextProvider } from "../../../media";


function InterestingBlog(props) {  
  return (
    <>
    <MediaContextProvider>
        <Media greaterThanOrEqual="md">
          <div id="interestingBlog">
            <h3>Interesting Blogs</h3>
              {
                PACKAGING_BLOG.map((interesting, index)=>(
                  (index === props.interest01 || index === props.interest02 || index === props.interest03 || index === props.interest04) &&
                  <React.Fragment key={index}>
                    <Link to={toRoute("/blog"+interesting.path)}>
                    <Image 
                      src={asset(`${interesting.blogInterestingImageDesktop}`)} 
                      className="zoom"
                      alt="Luxury-Packaging-Market" 
                      width="100%" 
                      height="auto" 
                    />
                    </Link>
                    <p><Image
                        src={asset(`/images/packagingBlog/desktop/postDate.svg`)}
                        alt="postDate"
                        className="img-fluid"
                        width="20"
                        height="20"
                        style={{marginRight: "5px"}}
                      />{interesting.datePost}</p>
                    <Link to={toRoute("/blog"+interesting.path)}>
                      <h4>{interesting.blogName}</h4>
                    </Link>
                  </React.Fragment>
                ))
              }
          </div>
        </Media>
        <Media lessThan="md">
          <div id="interestingBlogMobile">
            <h3>Interesting Blogs</h3>
              {
                PACKAGING_BLOG.map((interesting, index)=>(
                  (index === props.interest01 || index === props.interest02 || index === props.interest03 || index === props.interest04) &&
                  <React.Fragment key={index}>
                    <Link to={toRoute("/blog"+interesting.path)}>
                      <Image 
                        src={asset(`${interesting.blogInterestingImageMobile}`)} 
                        className="zoom"
                        alt="Luxury-Packaging-Market" 
                        width="100%" 
                        height="auto" 
                      />
                    </Link>
                    <p><Image
                        src={asset(`/images/packagingBlog/desktop/postDate.svg`)}
                        alt="postDate"
                        className="img-fluid"
                        width="10"
                        height="10"
                        style={{marginRight: "5px"}}
                      />{interesting.datePost}</p>
                    <Link to={toRoute("/blog"+interesting.path)}>
                      <h4>{interesting.blogName}</h4>
                    </Link>
                  </React.Fragment>
                ))
              }
          </div>
        </Media>
      </MediaContextProvider>

    </>
  );
}

export default InterestingBlog;
